module.exports = __webpack_public_path__ + "static/media/payza-dark.aaf8d63f.svg";